<div id="query-logic-tab-wrapper">
  <!-- Static info banner -->
  <div id="query-logic-banner">
    <hyperkit-banner
      type="info"
      text="This table provides a tool-agnostic language to help analysts understand how queries should function on their system. Each row represents an indicator of suspicious activity, with optional exclusions and boolean logic defining how selections combine into a final query."
      [closable]="true"
    ></hyperkit-banner>
  </div>

  <!-- Logic table -->
  <div id="query-logic-table">
    <div class="table-container">
      <table class="data-table">
        <thead>
          <tr>
            @for (column of columns; track column) {
              <th>
                <hyperkit-typography
                  variant="emphasized"
                  size="sm"
                  align="left"
                  color="body"
                >
                  {{ column.header }}
                </hyperkit-typography>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (logic of rows(); track logic) {
            <tr>
              @for (column of columns; track column) {
                <td>
                  <hyperkit-typography
                    variant="body"
                    size="md"
                    align="left"
                    color="body"
                  >
                    {{ logic[column.field] }}
                  </hyperkit-typography>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
